import { formatPhoneNumber } from "@elit-hair/elit-tools";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@elit-hair/elit-ui";
import { useTranslation } from "react-i18next";

import type { Call } from "@/types/call.types";

type StaleCallConfirmDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    call: Call | null;
    onConfirm: () => void;
    onCancel: () => void;
};

export function StaleCallConfirmDialog({ open, onOpenChange, call, onConfirm, onCancel }: StaleCallConfirmDialogProps) {
    const { t } = useTranslation();

    const handleConfirm = () => {
        onConfirm();
        onOpenChange(false);
    };

    const handleCancel = () => {
        onCancel();
        onOpenChange(false);
    };

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t("call_stale_warning_title")}</AlertDialogTitle>
                    <AlertDialogDescription>
                        <p>{t("call_stale_warning_description")}</p>
                        {call?.calledNumber && (
                            <p className="mt-2 font-medium">
                                {call.calledName?.trim()
                                    ? t("call_stale_call_target_with_name", {
                                          name: call.calledName.trim(),
                                          number: formatPhoneNumber(call.calledNumber, { format: "INTERNATIONAL" }),
                                      })
                                    : t("call_stale_call_target_number_only", {
                                          number: formatPhoneNumber(call.calledNumber, { format: "INTERNATIONAL" }),
                                      })}
                            </p>
                        )}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={handleCancel}>{t("cancel")}</AlertDialogCancel>
                    <AlertDialogAction onClick={handleConfirm}>{t("call_stale_confirm_call")}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
